import { motion } from 'framer-motion';
const LOGO_URL = 'https://cdn.magicpatterns.com/uploads/q7RnjxXyHz353QdkW84P8k/IMG_5459.jpg';
const GOLD = '#C9A96E';
const highlights = ['8 esenciales incluidos', 'Estuche organizado', 'Fácil de llevar'];
export function KitExplainer() {
  return <section className="relative overflow-hidden px-5 sm:px-6 pt-10 pb-10 sm:pt-14 sm:pb-12 lg:pt-16 lg:pb-16 bg-nude-light" data-id="element-177" data-mp="ayj2kbk7ying">
      {/* Brand watermark */}
      <img src={LOGO_URL} alt="" aria-hidden="true" loading="lazy" decoding="async" className="pointer-events-none select-none absolute left-1/2 top-1/2 -translate-x-1/2 -translate-y-1/2 w-[150%] max-w-[380px] sm:max-w-[560px] lg:max-w-[760px] mix-blend-multiply opacity-[0.05] z-0" data-id="element-178" data-mp="13hbha6dv6i8" />

      <div className="relative z-10 max-w-3xl mx-auto text-center" data-id="element-179" data-mp="3janncqlq1qa2">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.7
      }} data-id="element-180" data-mp="1mfitp3utyrfw">
          <div className="mx-auto mb-8 sm:mb-10 h-[1px] w-14" style={{
          backgroundColor: GOLD
        }} data-id="element-181" data-mp="s9xode6mdaoj" />

          <p className="text-[11px] sm:text-xs font-sans font-medium uppercase tracking-[0.25em] sm:tracking-[0.3em] mb-4" style={{
          color: GOLD
        }} data-id="element-182" data-mp="wardubzpmxjj">
            Tu kit, listo para acompañarte
          </p>

          <h2 className="font-serif text-luxury-black mx-auto max-w-[24ch] mb-5 sm:mb-6" style={{
          fontSize: 'clamp(1.75rem, 5vw, 2.75rem)',
          lineHeight: 1.15
        }} data-id="element-183" data-mp="1b1qhr9ploxws">
            Más que un estuche. Todo lo esencial, en un solo lugar.
          </h2>

          <div className="font-sans font-light text-gray-600 mx-auto max-w-[52ch] space-y-4" style={{
          fontSize: 'clamp(0.9375rem, 1.5vw, 1.0625rem)',
          lineHeight: 1.6
        }} data-id="element-184" data-mp="169yy7j4v3sg5">
            <p data-id="element-185" data-mp="28njja0cz84lc">
              Alexa Beauty reúne en un kit compacto 8 esenciales de belleza y
              organización, pensados para mantener tus herramientas protegidas,
              ordenadas y siempre a tu alcance.
            </p>
            <p data-id="element-186" data-mp="1yocbrtsxb465">
              Ideal para lash artists, profesionales de belleza, principiantes o
              para llevar tus esenciales contigo todos los días.
            </p>
          </div>
        </motion.div>

        {/* Micro highlights */}
        <motion.ul initial={{
        opacity: 0,
        y: 16
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6,
        delay: 0.15
      }} className="mt-9 sm:mt-11 flex flex-col sm:flex-row items-center justify-center gap-3 sm:gap-6 lg:gap-10" data-id="element-187" data-mp="1pqigmm6wagkk">
          {highlights.map((item, i) => <li key={item} className="flex items-center gap-6 lg:gap-10 text-[11px] sm:text-xs font-sans font-medium uppercase tracking-[0.2em] text-luxury-dark" data-id="element-188" data-mp="16xo9ufjfdurf" data-mpi={i}>
              {i > 0 && <span className="hidden sm:block h-3 w-[1px] shrink-0" style={{
            backgroundColor: GOLD
          }} aria-hidden="true" data-id="element-189" data-mp="3doswbhkbi389" />}
              {item}
            </li>)}
        </motion.ul>

        {/* Editorial close */}
        <motion.div initial={{
        opacity: 0
      }} whileInView={{
        opacity: 1
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.8,
        delay: 0.2
      }} className="mt-10 sm:mt-12" data-id="element-190" data-mp="2uvyvdrjj4bn1">
          <p className="font-serif italic text-luxury-black mx-auto max-w-[36ch]" style={{
          fontSize: 'clamp(1.125rem, 2.4vw, 1.5rem)',
          lineHeight: 1.4
        }} data-id="element-191" data-mp="33wewiucsv6oq">
            "Dos estilos. El mismo propósito: tener lo que necesitas siempre
            contigo."
          </p>

          <p className="mt-6 sm:mt-7 text-[11px] sm:text-xs font-sans font-medium tracking-[0.25em] uppercase text-gray-500" data-id="element-192" data-mp="2g4zl8c31pf1c">
            Elige el que va contigo ↓
          </p>
        </motion.div>
      </div>
    </section>;
}